// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1zvBR","label":"Labeled_label__3troq","divider":"Labeled_divider__2WZd6"};